// extracted by mini-css-extract-plugin
export var centerText = "_b8-8";
export var container = "_b8-0";
export var doughnutContainer = "_b8-7";
export var legend = "_b8-a";
export var legendItemColorDisplay = "_b8-b";
export var legendItemLabel = "_b8-c";
export var lg = "_b8-5";
export var maxWidth = "_b8-9";
export var md = "_b8-4";
export var responsive = "_b8-6";
export var sm = "_b8-3";
export var xs = "_b8-2";
export var xxs = "_b8-1";